<mat-button-toggle-group
  [value]="selectedToolMode$ | async"
  (change)="setMode($event.value)"
>
  <mat-button-toggle
    class="toolbar-button"
    matTooltip="Free point mode: measure between two ground points"
    [value]="freePointModeValue"
  >
    <mat-icon [h3CustomIcon]="freePointModeIcon"></mat-icon>
  </mat-button-toggle>
  @if (hasOrthographicVideoOutput) {
    <mat-button-toggle
      class="toolbar-button"
      matTooltip="Subpoint mode: measure the height distance from a subpoint"
      [value]="subpointModeValue"
    >
      <mat-icon [h3CustomIcon]="subpointModeIcon"></mat-icon>
    </mat-button-toggle>
  }
</mat-button-toggle-group>
